<script setup lang="ts">
/**
 * Bandiera di una lingua.
 *
 * L'immagine arriva da `languages.flag_url`, così aggiungere una lingua dal
 * pannello non richiede un rilascio del frontend. Per le due lingue storiche,
 * che a database non hanno un URL, restano le SVG inline: sono nitide, non
 * costano una richiesta e le emoji bandiera non si vedono su Windows.
 *
 * Una lingua nuova senza `flag_url` mostra il suo codice: meglio una sigla
 * corretta che la bandiera sbagliata di un'altra nazione.
 */
const props = defineProps<{ locale: string; src?: string | null }>()

const SHAPE = 'h-3.5 w-5 shrink-0 rounded-sm ring-1 ring-black/20'
</script>

<template>
  <img
    v-if="props.src"
    :src="props.src"
    :class="[SHAPE, 'object-cover']"
    alt=""
    aria-hidden="true"
  />

  <svg v-else-if="props.locale === 'it'" :class="SHAPE" viewBox="0 0 3 2" aria-hidden="true">
    <rect x="0" width="1" height="2" fill="#008C45" />
    <rect x="1" width="1" height="2" fill="#F4F5F0" />
    <rect x="2" width="1" height="2" fill="#CD212A" />
  </svg>

  <!-- Union Jack semplificata, leggibile a 20px. -->
  <svg v-else-if="props.locale === 'en'" :class="SHAPE" viewBox="0 0 60 40" aria-hidden="true">
    <rect width="60" height="40" fill="#012169" />
    <path d="M0 0 60 40M60 0 0 40" stroke="#FFF" stroke-width="8" />
    <path d="M0 0 60 40M60 0 0 40" stroke="#C8102E" stroke-width="4" />
    <path d="M30 0V40M0 20H60" stroke="#FFF" stroke-width="13" />
    <path d="M30 0V40M0 20H60" stroke="#C8102E" stroke-width="8" />
  </svg>

  <span
    v-else
    :class="[
      SHAPE,
      'bg-abyss-700 flex items-center justify-center text-[9px] font-bold text-white',
    ]"
    aria-hidden="true"
    >{{ props.locale.toUpperCase() }}</span
  >
</template>
